import { FC } from 'react';

const SuccessIcon: FC = () => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 11.0801V12.0001C20.9988 14.1565 20.3005 16.2548 19.0093 17.9819C17.7182 19.7091 15.9033 20.9726 13.8354 21.584C11.7674 22.1954 9.55726 22.122 7.53447 21.3747C5.51168 20.6274 3.78465 19.2462 2.61096 17.4372C1.43727 15.6281 0.879791 13.4882 1.02168 11.3364C1.16356 9.18467 1.99721 7.13643 3.39828 5.49718C4.79935 3.85793 6.69279 2.71549 8.79619 2.24025C10.8996 1.76502 13.1003 1.98245 15.07 2.86011M21 4.00011L11 14.0101L8.00001 11.0101"
        stroke="inherit"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SuccessIcon;
